import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import ContentFrom from '../../components/ContentForm'
import {
  useContent,
  useDeleteContent,
  useUpdateContent,
} from '../../hooks/contents'
import { Content } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'

export default function ContentEdit() {
  const { id } = useParams()
  const { data: content } = useContent(+id!)
  const deleteContent = useDeleteContent()
  const updateContent = useUpdateContent()
  const [modalRm, modalRmActions] = useModalTrigger<Content>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/contents">Contenuti</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {content!.code}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(content)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <ContentFrom
          content={content}
          save={(formContent) =>
            updateContent.mutateAsync(formContent).then(() =>
              toast.success('Contenuto salvato con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il Contenuto {modalRm.value.code} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteContent.isLoading}
            onClick={async () => {
              await deleteContent.mutateAsync(modalRm.value!.id)
              navigate('/contents')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
